import React, { createContext, useContext } from "react";

export const EventTabContext = createContext(null);

export function useEventTab() {
  const ctx = useContext(EventTabContext);
  if (!ctx) throw new Error("useEventTab must be used within EventTabContext.Provider");
  return ctx;
}
